/**
 * ResposivePanelWrapper
 * 
 * @Author: Focci
 * @Date: 2023-10-11 16:10:34
 * @Last Modified by: Focci
 * @Last Modified time: 2023-10-11 16:10:34
 */

import useApp from '@hook/useApp'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import { Popper, Dialog } from '@comp/material'
import { styled } from '@mui/material/styles'

const StyledPopper = styled(Popper)(({ anchorEl, theme }) => {
  const { width } = anchorEl ? anchorEl.getBoundingClientRect() : 300
  return ({
    border: '1px solid #e1e4e8',
    borderRadius: 4,
    width,
    zIndex: theme.zIndex.modal,
    backgroundColor: '#fff'
  })
})

function DropdownPopper({
  children,
  open,
  anchorEl,
  onClose = () => {},
}) {
  return (
    <StyledPopper
      placement="bottom-start"
      {...({ open, anchorEl })}
    >
      <ClickAwayListener onClickAway={onClose}>
        <div className="shadow-lg">
          {children}
        </div>
      </ClickAwayListener>
    </StyledPopper>
  )
}

function FullscreenPopper({
  children,
  open,
}) {
  return (
    <Dialog fullScreen open={open}>
      {children}
    </Dialog>
  )
}

export default function ResposivePanelWrapper({
  children,
  ...props
}) {
  const { isMobile } = useApp()
  const Wrapper = isMobile 
    ? FullscreenPopper 
    : DropdownPopper

  return (
    <Wrapper {...props}>
      {children}
    </Wrapper>
  )
}
